module.exports = __webpack_public_path__ + "static/more-money-than-god-caef2eac9303cd03cc5aebd878b65064.jpg";